// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"App_wrapper__3nkFE","headerFixed":"App_headerFixed__1D3Pn","logo":"App_logo__18efm","logoTitle":"App_logoTitle__1p1rX"};